(function () {
  function autoSelect(picker) {
    if (picker.dataset.smAutoSelected === 'done') return;

    var scripts = picker.querySelectorAll('script[type="application/json"][data-resource]');
    if (scripts.length === 0) return;

    var cheapestPrice = Infinity;
    var cheapestInputId = null;

    scripts.forEach(function (s) {
      try {
        var v = JSON.parse(s.textContent);
        if (!v || !v.available) return;
        if (v.price < cheapestPrice) {
          cheapestPrice = v.price;
          cheapestInputId = s.dataset.resource;
        }
      } catch (e) {}
    });

    if (!cheapestInputId) return;

    var input = picker.querySelector('#' + CSS.escape(cheapestInputId));
    if (!input) return;

    picker.dataset.smAutoSelected = 'done';

    if (input.checked) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function runAll() {
    document.querySelectorAll('variant-picker').forEach(autoSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  document.addEventListener('quickview:loaded', function () {
    setTimeout(runAll, 50);
  });
})();